export { default as Img200 } from './processed/200/Deuce-The-S1.jpg';
export { default as Img400 } from './processed/400/Deuce-The-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Deuce-The-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Deuce-The-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Deuce-The-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      212,
      110,
      53
    ],
    "_population": 1158,
    "_hsl": [
      0.05974842767295598,
      0.6489795918367348,
      0.5196078431372549
    ]
  },
  "LightVibrant": {
    "_rgb": [
      234,
      203,
      169
    ],
    "_population": 2043,
    "_hsl": [
      0.08717948717948716,
      0.6074766355140184,
      0.7901960784313725
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      108,
      56,
      28
    ],
    "_population": 613,
    "_hsl": [
      0.05833333333333333,
      0.5882352941176471,
      0.26666666666666666
    ]
  },
  "Muted": {
    "_rgb": [
      140,
      132,
      119
    ],
    "_population": 5,
    "_hsl": [
      0.10317460317460321,
      0.08366533864541838,
      0.5078431372549019
    ]
  },
  "LightMuted": {
    "_rgb": [
      212,
      196,
      188
    ],
    "_population": 2,
    "_hsl": [
      0.05555555555555555,
      0.21818181818181828,
      0.7843137254901962
    ]
  },
  "DarkMuted": {
    "_rgb": [
      79,
      57,
      47
    ],
    "_population": 655,
    "_hsl": [
      0.052083333333333336,
      0.25396825396825395,
      0.24705882352941178
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Deuce-The-S1.js